import React from 'react';
import { BodyText } from '@block-explorer/ui';
import { HistoryLink } from '../history-link/history-link';
import Avatar from '../avatar/avatar';
import { useTranslation } from 'react-i18next';
import TooltipWithExtendedInfo from '../tooltip-with-extended-info/tooltip-with-extended-info.tsx';

interface AccountInfoIconProps {
  publicKey: string;
  csprName?: string | undefined;
  logo: string | null;
  path: string;
}

export const AccountInfoIcon = ({
  publicKey,
  csprName,
  logo,
  path,
}: AccountInfoIconProps) => {
  const { t } = useTranslation();
  return (
    <TooltipWithExtendedInfo
      hash={publicKey}
      extendedLine={{ title: csprName, caption: t('CSPR.name') }}
    >
      <BodyText size={3} monotype>
        <HistoryLink href={path} ariaDescription={'Link to account details'}>
          {logo ? (
            <Avatar src={logo} size={'tiny'} alt={'Account logo'} />
          ) : (
            <Avatar hash={publicKey} size={'tiny'} />
          )}
        </HistoryLink>
      </BodyText>
    </TooltipWithExtendedInfo>
  );
};
